import { RootState } from '@Redux/store'
import { createSelector } from '@reduxjs/toolkit'

import { Order, Trade } from '@App/redux/slices/trade/trades/types'

export const selectAccountsTradesList = (state: RootState) => state.trades.tradesList

export const selectAccountsOrdersList = (state: RootState) => state.orders.ordersList

export const selectTradesList = (state: RootState) => state.user.curr_wallet?.id ? state.trades.tradesList[state.user.curr_wallet.id] ?? [] : []

export const selectOrdersList = (state: RootState) => state.user.curr_wallet?.id ? state.orders.ordersList[state.user.curr_wallet.id] ?? [] : []

export const selectOpenedTrades = createSelector([selectTradesList], (tradesList) =>
  tradesList.filter((trade) => trade.status === 'open'),
)

export const selectOpenedOrders = createSelector([selectOrdersList], (ordersList) =>
  ordersList.filter((order) => order.status === 'open'),
)

export const selectOpenedTradesAndOrdersCount = createSelector(
  [selectOpenedTrades, selectOpenedOrders],
  (openedTrades, openedOrders) => openedOrders.length + openedTrades.length,
)

export const selectGroupedOpenedTrades = createSelector([selectOpenedTrades], (openedTrades) => {
  if (!openedTrades.length) return []

  const grouped = openedTrades.reduce<Record<string, Trade[]>>((acc, order) => {
    const key = order.market?.title
    if (!acc[key]) acc[key] = []
    acc[key].push(order)
    return acc
  }, {})

  return Object.values(grouped)
})

export const selectGroupedOpenedOrders = createSelector([selectOpenedOrders], (openedOrders) => {
  if (!openedOrders.length) return []

  const grouped = openedOrders.reduce<Record<string, Order[]>>((acc, order) => {
    const key = order.market?.title
    if (!acc[key]) acc[key] = []
    acc[key].push(order)
    return acc
  }, {})

  return Object.values(grouped)
})

export const selectGroupedOpenedTradesByTitle = createSelector(
  selectOpenedTrades,
  (_: RootState, title: string) => title,
  (openedTrades, title) => {
    return openedTrades.filter((trade: Trade) => trade.market?.title === title)
  },
)
export const selectGroupedOpenedOrdersByTitle = createSelector(
  selectOpenedOrders,
  (_: RootState, title: string) => title,
  (openedOrders, title) => {
    return openedOrders.filter((order: Order) => order.market?.title === title)
  },
)

export const selectTradeToEdit = (state: RootState) => state.trades.tradeToEdit
export const selectOrderToEdit = (state: RootState) => state.orders.orderToEdit

export const tradesIsLoading = (state: RootState) => state.trades.isLoading
